<template>
    <section class="card">
        {{ label }}
        <tr-text v-bind="$attrs.props.label" :tracker="tracker" @edit-tr="$emit('edit-tr', $event)" />
        <tr-text v-bind="$attrs.props.text"  :tracker="tracker" @edit-tr="$emit('edit-tr', $event)" />
    </section>
</template>

<script>
import TrText from "@/components/translation/TrText"

export default {
    name:     "I18nMessagebox",
    components: {TrText},
    props: {
        tracker: Array,
        index: Number,
    }
}
</script>

<style>
</style>